import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const canPushProduct = map.useCanPushProduct()

    if (! canPushProduct) {
        return null
    }

    return {
        key: 'push-product',
        label: '保存且更新',
        suffix: 'Ctrl+S',
        onClick: () => map.cmdPushSave(),
    }
}
